<div class="p-6 lg:p-8">

  <!-- Page header -->
  <div class="mb-6">
    <h1 class="text-xl font-semibold text-slate-900">Settings</h1>
    <p class="mt-1 text-sm text-slate-500">Manage your account, billing, and integrations.</p>
  </div>

  <div class="flex gap-6 lg:gap-8">

    <!-- Sub-nav -->
    <nav class="w-44 flex-shrink-0">
      <ul class="space-y-0.5">
        <li>
          <a
            routerLink="account"
            routerLinkActive="bg-violet-50 text-violet-700 font-medium"
            class="flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
          >
            <lucide-icon name="user" [size]="16" [strokeWidth]="1.75" class="flex-shrink-0"></lucide-icon>
            Account
          </a>
        </li>
        <li>
          <a
            routerLink="billing"
            routerLinkActive="bg-violet-50 text-violet-700 font-medium"
            class="flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
          >
            <lucide-icon name="credit-card" [size]="16" [strokeWidth]="1.75" class="flex-shrink-0"></lucide-icon>
            Billing
          </a>
        </li>
        <li>
          <a
            routerLink="integrations"
            routerLinkActive="bg-violet-50 text-violet-700 font-medium"
            class="flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
          >
            <lucide-icon name="plug-2" [size]="16" [strokeWidth]="1.75" class="flex-shrink-0"></lucide-icon>
            Integrations
          </a>
        </li>
        <li>
          <a
            routerLink="team"
            routerLinkActive="bg-violet-50 text-violet-700 font-medium"
            class="flex items-center gap-2.5 rounded-lg px-3 py-2 text-sm text-slate-600 transition-colors hover:bg-slate-100 hover:text-slate-900"
          >
            <lucide-icon name="users" [size]="16" [strokeWidth]="1.75" class="flex-shrink-0"></lucide-icon>
            Team
          </a>
        </li>
      </ul>
    </nav>

    <!-- Content area -->
    <div class="min-w-0 flex-1">
      <router-outlet></router-outlet>
    </div>

  </div>
</div>
